import { render, html } from "lit-html";
import connect from "@escapio/shared/data-store/connect";
import { store, ACTION_SET_FILTER } from "./DataStore";
import { track } from "../../tracker/EventTracker";

customElements.define(
	"esc-profile-filter-checkbox",
	class extends connect(HTMLElement, store) {
		connectedCallback() {
			this.filterName = this.getAttribute("name");
			this.labelText = this.getAttribute("label");
			this.eventLabel = this.getAttribute("event-label");
			super.connectedCallback();
		}

		update(state, store) {
			const checked = state.filters[this.filterName] === this.checkedValue;

			const template = html` <label class="form-checkbox">
				<input
					type="checkbox"
					class="form-checkbox__input"
					@change=${this.onChange}
					?disabled=${!store.filterAvailable(this.filterName)}
					.checked=${checked}
				/>
				<span class="form-checkbox__label">${this.labelText}</span>
			</label>`;
			return render(template, this, { host: this });
		}

		onChange(event) {
			const { checked } = event.target;
			this.dispatchAction(ACTION_SET_FILTER, {
				[this.filterName]: checked ? this.checkedValue : this.uncheckedValue,
			});

			track(
				"Hotel",
				"Preis Filter",
				`${this.eventLabel}${checked ? "" : " entfernen"}`,
			);
		}

		get checkedValue() {
			return this.getAttribute("data-on") || true;
		}

		get uncheckedValue() {
			return this.getAttribute("data-off") || false;
		}
	},
);
